import { Navigate, Routes, Route, Outlet } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../_metronic/layout/core'

import { ReportList } from './ReportList'
import PermissionsService from '../auth/PermissionsService';

const ReportPageMails = () => {

  const userBreadCrumbs: Array<PageLink> = [
    {
      title: 'Reportes',
      path: 'mail-reports/',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ]

  const permissions = PermissionsService.getPermissions();
  const {
    hasConsumptionReportMails,

  } = permissions || {};



  return (
    <Routes>
      <Route element={<Outlet />}>
        {hasConsumptionReportMails ? (
          <Route
            path='list'
            element={
              <>
                <ReportList />
                <PageTitle breadcrumbs={userBreadCrumbs}>
                  Reporte de Emails masivos
                </PageTitle>
              </>
            }
          />

        ) : (
          <Route path='list' element={<Navigate to='/error/403' replace />} />
        )}

      </Route>
      <Route index element={<Navigate to='list' />} />
    </Routes>
  )
}

export default ReportPageMails
